<template>
  <blind-box-popup :is-visible="isVisible" @close="$emit('close')">
    <div class="result-popup-content">
      <div class="popup-header">
        <h1>Your Blind Box <br />is Here!</h1>
        <p class="popup-subtitle">
          Yuk, ambil blind box berisi surprise beauties kamu di bagian bawah Vending Machine ini.
          <br />Happy unboxing, Bestie!
        </p>
      </div>

      <div class="blind-box-container">
        <img src="/static/img/blind-box/global/dispense-popup.png" />
      </div>

      <div class="popup-actions" @click="$emit('close')">
        <img src="/static/img/blind-box/global/dispense-arrows.png" />
      </div>
    </div>
  </blind-box-popup>
</template>

<script>
export default {
  name: 'ResultPopup',
  components: {
    BlindBoxPopup: () => import('../ui/blind-box-popup.vue'),
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.result-popup-content {
  background: #ffffff;
  border-radius: 24px;
  height: 90vw;
  width: 700px;
  // width: 480px;
  // max-width: 90vw;
  padding: 40px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.popup-header {
  text-align: center;
  margin-bottom: 32px;

  h1 {
    font-size: 60px;
    font-weight: 900;
    color: #000000;
    margin: 0 0 16px 0;
    line-height: 1.2;
  }

  .popup-subtitle {
    font-size: 30px;
    font-weight: 400;
    color: #666666;
    line-height: 1.5;
    margin: 0;
  }
}

.blind-box-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}

.blind-box {
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  bottom: 0;
  background: linear-gradient(135deg, #2196f3 0%, #64b5f6 100%);
  border-radius: 8px;
  overflow: hidden;
}

.popup-actions {
  width: 100%;
  display: flex;
  justify-content: center;

  img {
    animation: bounceDown 1s infinite ease-in-out;
    cursor: pointer;

    &:hover {
      animation-play-state: paused;
    }
  }
}

@keyframes bounceDown {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(15px);
  }
}
</style>
